import { render, staticRenderFns } from "./talentRecruitment.vue?vue&type=template&id=20965cb0&scoped=true&"
import script from "./talentRecruitment.vue?vue&type=script&lang=js&"
export * from "./talentRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./talentRecruitment.vue?vue&type=style&index=0&id=20965cb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20965cb0",
  null
  
)

component.options.__file = "talentRecruitment.vue"
export default component.exports